import { zetApi } from '@zet/network'

export type VerifyEmploymentDetailsParams = {
  customerId: number
  employmentType: string
  bankNameList: string[]
  currentOccupation: string
  annualIncome: string
  partnerId: number
}

const verifyEmploymentDetails = async ({
  customerId,
  employmentType,
  bankNameList,
  currentOccupation,
  annualIncome,
  partnerId,
}: VerifyEmploymentDetailsParams) => {
  let apiEndPoint = '/customer/details/employment'
  if (partnerId) {
    apiEndPoint = `/customer/details/employment?partnerId=${partnerId}`
  }
  try {
    const { data } = await zetApi.post(apiEndPoint, {
      customerId,
      employmentType,
      bankNameList,
      currentOccupation,
      annualIncome,
    })

    return data?.data
  } catch (error) {
    throw 'Something went wrong'
  }
}
export { verifyEmploymentDetails }
